<template>
  <!-- ******** Inicio Lista de Contatos ******** -->
  <v-layout row>
    <v-flex xs12>
      <v-card flat>
        <v-list
          v-if="orderedUsers.length != 0"
          subheader
        >
          <virtualList
            :size="64"
            :remain="5"
          >
            <v-list-tile
              v-for="item in orderedUsers"
              :key="item.id"
              avatar
              class="mb-2"
              :to="`/contato/${item._id}`"
              @click="countDetails"
            >
              <v-list-tile-avatar :class="`mr-2 pl-2 ${item.situacao}`">
                <div v-lazy-container="{ error: 'https://s3.amazonaws.com/konselior/blankwhats.jpg', loading: 'https://s3.amazonaws.com/konselior/blankwhats.jpg' }">
                  <img
                    v-if="item.celular && item.celular.whatsapp"
                    class="avatarImg"
                    :data-src="item.celular.whatsapp.picture"
                  >
                  <img
                    v-if="!item.celular || !item.celular.whatsapp"
                    class="avatarImg"
                    :data-src="'https://s3.amazonaws.com/konselior/blankwhats.jpg'"
                  >
                </div>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title
                  class="client-name"
                  v-html="`${item.nome ? item.nome : ''} ${item.sobrenome ? item.sobrenome : ''}`"
                />
              <!-- <v-icon small color="#099AB1">fiber_manual_record</v-icon> -->
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn
                  fab
                  flat
                  small
                  color="#099AB1"
                >
                  <v-icon
                    small
                    color="primary"
                  >
                    $vuetify.icons.arrowRightIcon
                  </v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <div id="app">
              <infinite-loading
                v-show="orderedUsers.length != 0"
                spinner="spiral"
                @infinite="infiniteHandler"
              >
                <div slot="no-results">
                  Sem mais contatos :)
                </div>
                <div slot="no-more">
                  Sem mais contatos :)
                </div>
              </infinite-loading>
            </div>
          </virtualList>
        </v-list>
        <!-- ******** Fim Lista de Contatos ******** -->

        <!-- ******** Enquanto a pagina nao carrega ******** -->
        <div
          v-if="orderedUsers.length == 0"
          class="text-xs-center"
        >
          <v-progress-circular
            v-if="hasUsers"
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          />
          <div
            v-if="!hasUsers"
            class="animated fadeIn"
          >
            Não existem contatos neste segmento.
          </div>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import virtualList from 'vue-virtual-scroll-list';
import { APIService } from '@/resources/campanha.js';
import { PeopleBySituation } from '@/apollo';

const api = new APIService();

export default {
  props: {
    getter: String,
    setter: String,
    situacao: String,
  },
  data() {
    return {
      counterDetails: 0,
      lastLetter: null,
      loading: true,
      items: [],
      search: '',
      hasUsers: false,
      customer: null,
      page: 0,
    };
  },
  computed: {
    /* ******** Ordena Lista de Contatos ******** */
    orderedUsers() {
      return this.$store.getters[this.getter];
    },
    isSameFirstLetter(item) {
      if (!item.nome) {
        return false;
      }

      const letter = item.name.indexOf(0);
      const same = letter === lastLetter;

      if (!same) {
        lastLetter = letter;
      }
      return same;
    },
  },
  /* ******** Inicia funcao quando montado ******* */
  async mounted() {
    this.customer = this.$store.getters.getCustomer;
    const clientes = this.$store.getters[this.getter];

    if (!clientes || clientes.length == 0) {
      this.nextPage();
    } else if (clientes.length > 0 && clientes[0].lojaPreferida != this.$store.getters.getStore.name) {
      this.$store.commit(this.setter, []);
      this.nextPage();
    } else if (clientes.length > 0 && clientes.length < this.$store.getters.getCount[this.situacao]) {
      this.page = parseInt(clientes.length / 50);
    }
  },
  methods: {
    async infiniteHandler($state) {
      const users = this.$store.getters[this.getter];
      const listFinished = users.length >= this.$store.getters.getCount[this.situacao];

      if (listFinished) {
        $state.complete();
        return;
      }
      await this.nextPage();
      $state.loaded();
    },
    countDetails() {
      this.counterDetails += 1;

      this.$ga.event({
        eventCategory: 'Agenda',
        eventAction: 'Detalhar contato',
        eventValue: this.counterDetails,
      });
    },
    async getPeoplePaginated(sellerId, customerId, lojaPreferida, situacao, page) {
      const res = await this.$apollo.query({
        query: PeopleBySituation,
        variables: {
          customerId,
          sellerId,
          lojaPreferida,
          situation: situacao,
          page,
        },
        fetchPolicy: 'no-cache',
      });
      return res.data.getPaginatedPersonBySituation;
    },
    async nextPage() {
      this.$store.commit(this.setter.replace('SET_', 'ADD_'), await this.getPeoplePaginated(this.$auth.user.sub, this.customer.id, this.$store.getters.getStore.name, this.situacao.toUpperCase(), this.page));
      this.page++;
      this.hasUsers = this.$store.getters[this.getter].length > 0;
    },
  },
};
</script>

<style>
  .v-list__tile {
    padding-right: 0px;
    padding-left: 8px;
    border-bottom: 0.829458px solid #8A8691;
  }
  .avatarImg {
    max-width: 40px;
    max-height: 40px;
  }
  .client-name {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }

  .v-icon.ATIVO {
    color: #95d097 !important
  }
  .v-icon.RISCO {
    color: #ffc266 !important
  }
  .v-icon.INATIVO {
    color: #f7776e !important
  }
  .v-icon.PERDIDO {
    color: #6b6e73 !important
  }

  .v-icon.LEAD {
    color: #b834c7 !important
  }
    .v-list__tile__avatar.ATIVO {
    border-left: 3px solid #95d097 !important
  }
  .v-list__tile__avatar.RISCO {
    border-left: 3px solid #ffc266 !important
  }
  .v-list__tile__avatar.INATIVO {
    border-left: 3px solid #f7776e !important
  }
  .v-list__tile__avatar.PERDIDO {
    border-left: 3px solid #6b6e73 !important
  }
  .v-list__tile__avatar.LEAD {
    border-left: 3px solid #b834c7 !important
  }
  .v-list__tile__avatar.CREATE {
    border-left: 3px solid #ffffff !important
  }
</style>
